import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98dbee76"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "sakura-layer",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.petals, (p) => {
      return (_openBlock(), _createElementBlock("span", {
        key: p.id,
        class: _normalizeClass(["petal", p.shape]),
        style: _normalizeStyle(p.style)
      }, null, 6))
    }), 128))
  ]))
}